const populates = {
  userName: {
    child: 'userId',
    childAlias: 'userName',
    root: 'users/public',
    childParam: 'displayName'
  },
  boardName: {
    child: 'boardId',
    childAlias: 'boardName',
    root: 'boards',
    childParam: 'name'
  }
}

export default populates